import RocketImg from "public/migrationToMost/rocket.png";
import CubesImg from "public/migrationToMost/cubes.png";
import LightImg from "public/migrationToMost/light.png";
import VerifyImg from "public/migrationToMost/verify.png";

export const MIGRATION_CONSTANTS = {
  TITLE: " Your Migration Journey, Our Proven Playbook",
  ITEMS: [
    {
      image: RocketImg,
      title: "Discovery ",
      text: "Assessment of workloads, architecture, dependencies, and licensing. ",
    },
    {
      image: LightImg,
      title: "Planning & Architecture ",
      text: " Tailored migration roadmap with optimized compute/storage/network design. ",
    },
    {
      image: CubesImg,
      title: " Automation-Driven Migration ",
      text: " Tooling and scripts to perform low-downtime migration with validation. ",
    },
    {
      image: VerifyImg,
      title: "Validation & Cutover ",
      text: "  Testing, phased cutovers, rollback planning, and post-migration optimization. ",
    },
  ],
};
